// extracted by mini-css-extract-plugin
export var lContent = "content-module--l-content--2d1-W";
export var lContent__inner = "content-module--l-content__inner--ZKkOM";
export var lContentFull = "content-module--l-content--full--1H17K";
export var lContent__innerTransparent = "content-module--l-content__inner--transparent--2XqHy";
export var lContentPageTitle = "content-module--l-content--pageTitle--2gF5w";
export var standby = "content-module--standby--3tHI2";
export var visible = "content-module--visible--PDznL";